import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../../interfaces/user';
import { UserService } from '../../../services/user.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  user: User;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';

  constructor(private userService: UserService, private toastr: ToastrService) {}

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.reset();
    }
    this.user = {
      id: 0,
      password: '',
      email: '',
      firstname: '',
      lastname: ''
    };
  }

  OnSubmit(form: NgForm) {
    this.userService.registerUser(form.value).subscribe(
      (data: any) => {
        this.resetForm(form);
        this.toastr.success('User registration successful');
      },
      (err) => {
        this.resetForm(form);
        this.toastr.error(err.message.replace('GraphQL error:', '').trim());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/user/sign-up/sign-up.component.ts